export default {
  privacy: {
    i18nOptions: { namespaces: ['privacy'] },
  }

};
